export const StandoutImage = (): React.ReactElement => {
  return (
    <svg
      width="144"
      height="101"
      viewBox="0 0 144 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_862_1273)">
        <rect x="4" y="4" width="128" height="84.9346" rx="8" fill="white" />
        <g clipPath="url(#clip0_862_1273)">
          <path
            d="M4 12C4 7.58172 7.58172 4 12 4H124C128.418 4 132 7.58172 132 12V21.3458H4V12Z"
            fill="#F0DC28"
          />
          <path
            d="M62.5987 16.096C63.8547 16.096 64.8387 15.48 65.1507 14L63.4867 13.64C63.3907 14.272 63.1827 14.624 62.7747 14.624C62.2547 14.624 62.0307 14.192 62.0307 13.28C62.0307 12.296 62.2707 11.744 62.8067 11.744C63.1907 11.744 63.3987 12 63.4787 12.616L65.1027 12.216C64.9027 10.928 63.9827 10.304 62.7987 10.304C61.1907 10.304 60.1267 11.392 60.1267 13.28C60.1267 15.072 61.0467 16.096 62.5987 16.096ZM67.7486 14.96C67.4126 14.96 67.2526 14.648 67.2446 14.136H69.5006C69.6766 12.784 69.0846 11.776 67.6446 11.776C66.3726 11.776 65.5326 12.656 65.5326 13.936C65.5326 15.232 66.2286 16.096 67.5726 16.096C68.5566 16.096 69.2286 15.672 69.5246 14.896L68.3246 14.4C68.1806 14.808 67.9886 14.96 67.7486 14.96ZM67.6766 12.864C67.9566 12.864 68.0446 13.096 68.0366 13.456H67.2686C67.2926 13.088 67.4286 12.864 67.6766 12.864ZM72.8659 11.776C72.2659 11.776 71.9459 12.096 71.7699 12.888H71.7539V11.872H70.1379V16H71.8179V14.184C71.8499 13.328 72.1459 13.16 72.4419 13.16C72.6419 13.16 72.8019 13.256 73.0099 13.432L73.6339 12.064C73.3539 11.848 73.0819 11.776 72.8659 11.776ZM76.9868 14.824C76.8508 14.888 76.7228 14.928 76.5948 14.928C76.4108 14.928 76.3068 14.832 76.3068 14.6V12.88H77.0908V11.872H76.3068V10.712H74.6268V11.872H73.9548V12.88H74.6268V14.68C74.6268 15.608 75.0748 16.096 76.0508 16.096C76.4428 16.096 76.8348 16 77.2108 15.8L76.9868 14.824ZM77.7785 11.504H79.4585V10.08H77.7785V11.504ZM77.7785 16H79.4585V11.872H77.7785V16ZM82.7842 11.24C82.9282 11.24 83.0482 11.28 83.1762 11.352L83.4882 10.272C83.1922 10.096 82.8242 9.984 82.4162 9.984C81.5122 9.984 80.7602 10.432 80.7602 11.632V11.872H80.0642V12.88H80.7602V16H82.4402V12.88H83.3042V11.872H82.4402V11.632C82.4402 11.384 82.5682 11.24 82.7842 11.24ZM83.9282 10.08V11.504H85.6082V10.08H83.9282ZM83.9282 16H85.6082V11.872H83.9282V16ZM88.4127 14.96C88.0767 14.96 87.9167 14.648 87.9087 14.136H90.1647C90.3407 12.784 89.7487 11.776 88.3087 11.776C87.0367 11.776 86.1967 12.656 86.1967 13.936C86.1967 15.232 86.8927 16.096 88.2367 16.096C89.2207 16.096 89.8927 15.672 90.1887 14.896L88.9887 14.4C88.8447 14.808 88.6527 14.96 88.4127 14.96ZM88.3407 12.864C88.6207 12.864 88.7087 13.096 88.7007 13.456H87.9327C87.9567 13.088 88.0927 12.864 88.3407 12.864ZM93.068 10.08V12.672H93.052C92.892 12.048 92.54 11.776 92.036 11.776C91.124 11.776 90.556 12.584 90.556 13.936C90.556 15.288 91.092 16.096 92.036 16.096C92.548 16.096 92.948 15.816 93.116 15.184H93.132V16H94.748V10.08H93.068ZM93.068 14.048C93.052 14.576 92.932 14.848 92.676 14.848C92.404 14.848 92.268 14.568 92.268 13.936C92.268 13.304 92.404 13.024 92.676 13.024C92.94 13.024 93.06 13.304 93.068 13.824V14.048Z"
            fill="black"
          />
          <g clipPath="url(#clip1_862_1273)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.9346 3.40234L44.0443 9.50533C44.4321 9.07696 44.8933 8.71757 45.4085 8.44536C45.9897 8.13637 46.6183 7.9414 47.2887 7.85541L47.7034 6.95647L47.1022 5.6886C46.4402 4.29238 45.0331 3.40234 43.4879 3.40234H40.9346ZM55.2897 3.40234L52.1508 9.48003C51.7678 9.06278 51.3146 8.71217 50.8095 8.44533C49.9969 8.0135 49.0915 7.80436 48.1091 7.80421L48.0533 7.80444L49.0115 5.72696C49.6652 4.3099 51.0832 3.40234 52.6438 3.40234H55.2897ZM48.1121 8.33692C47.2214 8.33692 46.421 8.5296 45.7109 8.91494C45.0139 9.29038 44.4306 9.8527 44.0238 10.5413C43.6169 11.23 43.4019 12.0188 43.4019 12.8229C43.4019 13.627 43.6169 14.4159 44.0238 15.1045C44.4306 15.7931 45.0139 16.3555 45.7109 16.7309C46.4211 17.1161 47.2215 17.3088 48.1121 17.3089C49.0025 17.3089 49.803 17.1162 50.5134 16.7309C51.2103 16.3555 51.7936 15.7931 52.2005 15.1045C52.6074 14.4159 52.8224 13.627 52.8224 12.8229C52.8224 12.0188 52.6074 11.23 52.2005 10.5413C51.7936 9.8527 51.2103 9.29038 50.5134 8.91494C49.8032 8.52973 49.0028 8.33706 48.1121 8.33692ZM47.9085 10.1243C47.9886 9.95048 48.2357 9.95048 48.3158 10.1243L49.0088 11.6267C49.0415 11.6975 49.1086 11.7463 49.1861 11.7555L50.8291 11.9503C51.0191 11.9728 51.0955 12.2077 50.9549 12.3377L49.7402 13.461C49.683 13.514 49.6573 13.5929 49.6725 13.6694L49.995 15.2922C50.0323 15.4799 49.8324 15.6251 49.6654 15.5316L48.2217 14.7235C48.1536 14.6854 48.0707 14.6854 48.0026 14.7235L46.5589 15.5316C46.3919 15.6251 46.192 15.4799 46.2293 15.2922L46.5518 13.6694C46.567 13.5929 46.5413 13.514 46.4841 13.461L45.2693 12.3377C45.1288 12.2077 45.2052 11.9728 45.3952 11.9503L47.0382 11.7555C47.1157 11.7463 47.1828 11.6975 47.2155 11.6267L47.9085 10.1243Z"
              fill="black"
            />
          </g>
        </g>
        <rect
          x="11.1772"
          y="50.6523"
          width="47.2523"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <rect
          x="16.5605"
          y="57.8281"
          width="37.0841"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <rect
          x="9.98145"
          y="68.5977"
          width="49.6449"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <rect
          x="9.98145"
          y="75.7734"
          width="14.9533"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <rect
          x="27.3271"
          y="75.7734"
          width="14.9533"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <rect
          x="44.6729"
          y="75.7734"
          width="14.9533"
          height="4.78505"
          rx="2.39252"
          fill="#F0F0ED"
        />
        <g filter="url(#filter1_d_862_1273)">
          <rect
            x="18.355"
            y="27.9258"
            width="33.4953"
            height="14.3551"
            rx="2"
            fill="white"
          />
          <rect
            x="18.605"
            y="28.1758"
            width="32.9953"
            height="13.8551"
            rx="1.75"
            stroke="#C3C3BA"
            strokeWidth="0.5"
          />
        </g>
        <g opacity="0.65">
          <rect
            x="26.729"
            y="35.1016"
            width="6.76714"
            height="6.76714"
            rx="3.38357"
            transform="rotate(-45 26.729 35.1016)"
            fill="#7CCDD7"
          />
        </g>
        <g opacity="0.65">
          <rect
            x="30.916"
            y="35.1016"
            width="6.76714"
            height="6.76714"
            rx="3.38357"
            transform="rotate(-45 30.916 35.1016)"
            fill="#FF87B4"
          />
        </g>
        <g opacity="0.65">
          <rect
            x="35.1025"
            y="35.1016"
            width="6.76714"
            height="6.76714"
            rx="3.38357"
            transform="rotate(-45 35.1025 35.1016)"
            fill="#18D88F"
          />
        </g>
        <g clipPath="url(#clip2_862_1273)">
          <rect
            x="72.187"
            y="29.7188"
            width="53.2336"
            height="52.0374"
            rx="4"
            fill="#FAFAF9"
          />
          <rect
            x="75.1777"
            y="33.9062"
            width="47.2523"
            height="4.78505"
            rx="2.39252"
            fill="#E1E1DB"
          />
          <rect
            x="75.1777"
            y="70.9883"
            width="47.2523"
            height="4.78505"
            rx="2.39252"
            fill="#E1E1DB"
          />
          <rect
            x="79.9629"
            y="51.8477"
            width="37.6822"
            height="4.78505"
            rx="2.39252"
            fill="#E1E1DB"
          />
          <rect
            x="75.1777"
            y="59.625"
            width="14.3551"
            height="4.78505"
            rx="2.39252"
            fill="#F0DC28"
          />
          <rect
            x="91.9253"
            y="59.625"
            width="14.3551"
            height="4.78505"
            rx="2.39252"
            fill="#F0DC28"
          />
          <rect
            x="108.673"
            y="59.625"
            width="14.3551"
            height="4.78505"
            rx="2.39252"
            fill="#E1E1DB"
          />
          <rect
            x="75.1777"
            y="41.6797"
            width="47.2523"
            height="4.78504"
            rx="2.39252"
            fill="#DAF4EA"
          />
          <rect
            x="82.9531"
            y="78.7656"
            width="31.7009"
            height="4.78505"
            rx="2.39252"
            fill="#E1E1DB"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_862_1273"
          x="0"
          y="0"
          width="144"
          height="100.934"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_862_1273"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_862_1273"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_862_1273"
          x="14.355"
          y="27.9258"
          width="41.4951"
          height="22.3555"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_862_1273"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_862_1273"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_862_1273">
          <path
            d="M4 12C4 7.58172 7.58172 4 12 4H124C128.418 4 132 7.58172 132 12V21.3458H4V12Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_862_1273">
          <rect
            width="14.3551"
            height="14.3551"
            fill="white"
            transform="translate(40.9346 3.40234)"
          />
        </clipPath>
        <clipPath id="clip2_862_1273">
          <rect
            x="72.187"
            y="29.7188"
            width="53.2336"
            height="52.0374"
            rx="4"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
